var _path, _polyline;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorDefibrillator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21,36.873S3.085,29.929,3.085,15.499c0-5.952,4.178-10.372,9.769-10.372s8.146,4.69,8.146,4.69h0s2.554-4.69,8.146-4.69c5.592,0,9.769,4.419,9.769,10.372,0,14.43-17.915,21.374-17.915,21.374h0Z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "31.123 21.061 26.157 21.061 22.639 14.336 19.443 27.786 15.719 20.957 10.877 20.957"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorDefibrillator);
export default __webpack_public_path__ + "static/media/indoor-defibrillator.3988982d1073807b7911b923eeef12b9.svg";
export { ForwardRef as ReactComponent };